<template>
    <div class="attendances-empty_state">
      <img
        aria-hidden="true"
        alt=""
        src="~@/assets/images/checklist-pana.svg"
        class="attendances-empty_state__icon"
      />
      <p class="attendances-empty_state__description">
        W tym miejscu za kilka dni pojawią się informacje o obecnościach Twojego dziecka
      </p>
    </div>
  </template>

<script>
export default {
  name: 'AttendancesEmptyState',
};
</script>

  <style lang="scss" scoped>
  .attendances-empty_state {
    @apply flex flex-col justify-center items-center px-4 py-10 mt-10 bg-white;
    gap: 40px;

    @media screen and (min-width: 992px) {
      @apply px-8 py-12;
      gap: 32px;
    }

    &__icon {
      max-width: 200px;
      max-height: 200px;

      @media screen and (min-width: 992px) {
        max-width: 240px;
        max-height: 240px;
      }
    }

    &__description {
      color: #111724;
      text-align: center;
      font-family: "GT Walsheim Pro";
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;
      max-width: 770px;

      @media screen and (min-width: 992px) {
        font-size: 36px;
        line-height: 40px;
        letter-spacing: -0.72px;
      }

    }
  }
  </style>
